import React from 'react'
import AppRoutes from '../routes/appRoutes'

export const faqsItems = [
    {
        title: (
            <span>
                We have our own naming system for our trucks. Can I change them
                in LiftOne Now?
            </span>
        ),
        description: (
            <>
                Yes! Click on the <b>Fleet</b> tab in the menu, then choose an
                Asset. Under the <b>General Details</b> section, click{' '}
                <b>Update Customer Unit #</b> button and follow prompts. The new
                name will be auto-updated throughout LiftOne Now and in our
                system.
            </>
        ),
    },
    {
        title:
            'My company has multiple locations, but I’m only responsible for two. How can I change my settings to only see information related to those two?',
        description:
            'Click on your profile (your name at the bottom of the menu). Scroll to Location Preferences and select or deselect the locations you prefer.',
    },
    {
        title:
            'What happens if I no longer own a truck showing in my fleet list?',
        description: (
            <>
                Go to Fleet page and click on <b>Remove Assets</b> button in the
                top right corner. Select the asset(s) you would like removed,
                then click <b>Remove Assets</b> button again. A Chat window will
                appear with the assets you selected. Hit <b>Send</b> and they
                will be removed from your fleet within 2 business days.
            </>
        ),
    },
    {
        title: 'How do I use the filter to see my Rental trucks?',
        description: (
            <>
                From your <b>Fleet</b> tab, click on the <b>Filter By</b>{' '}
                button. Under <b>Ownership</b>, click the + sign, select Rented,
                then <b>View Results</b>.
            </>
        ),
    },
    {
        title:
            'My coworker needs access to LiftOne Now. Can they get an account, too?',
        description: (
            <>
                Yes, go to <b>Users</b> page, then click on{' '}
                <b>Invite Coworkers</b> and fill out form.
            </>
        ),
    },
    {
        title: 'I’m getting a new phone. How do I transfer my account?',
        description: (
            <>
                There’s no need to transfer! Simply go to Safari (iPhone) or
                Google Chrome (Android) and type{' '}
                <a
                    className="hover:underline text-links"
                    href={AppRoutes.home()}
                >
                    LiftOneNow.com
                </a>{' '}
                in your browser. Use your email address and password to login as
                you normally would. (We also recommend saving to your home
                screen for easier access).
            </>
        ),
    },
    {
        title: 'How do I sign out of LiftOne Now?',
        description: (
            <>
                Go to your profile page and click the <b>Sign Out</b> button at
                the top right.
            </>
        ),
    },
]
